import { createApp } from "vue";
import App from "@/App.vue";
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
const firebaseConfig = {
    apiKey: "AIzaSyD_4a3LEr9koJHmyV0PppG73s_XcOZM8ko",
    authDomain: "app-download-page.firebaseapp.com",
    projectId: "app-download-page",
    storageBucket: "app-download-page.appspot.com",
    messagingSenderId: "1039549301070",
    appId: "1:1039549301070:web:075793efbfa173e59fde1f",
    measurementId: "G-R7NRZRDDZE"
};
const fApp = initializeApp(firebaseConfig);
const Analytics = getAnalytics(fApp);
logEvent(Analytics, 'download_channel', 1);
const vm = createApp(App);
// Initialize Firebase
vm.config.globalProperties.$analytics = Analytics;
vm.mount("#app");
